import { generateClassName } from '@klv/shared/utils/functions';

import Icon from '@klv/atoms/icon';
import * as s from '../styles/button.module.css';

import type { IButtonProps } from '../types';

const Button = ({
  action, buttonColor = 'dark', children, className, rightIcon, leftIcon, iconColor, setTabIndex = 0, text, variant = 'primary', ...rest
}: IButtonProps) => {
  
  const cssClasses = [s[buttonColor], className];
  if (variant === 'none') {
    cssClasses.push(s.none);
  } else {
    cssClasses.push(s.button);
    cssClasses.push(s[variant]);
  }
  
  const sharedProps = {
    'aria-hidden': !!(!text || setTabIndex < 0),
    'aria-label': text && setTabIndex > -1 ? text : '',
    className: generateClassName(cssClasses),
    onClick: action,
    role: 'button',
    tabIndex: text ? setTabIndex : -1,
    variant,
  };
  const rightIconName = rightIcon?.iconName; 
  const leftIconName = leftIcon?.iconName;
  const colorIcon = iconColor ? `var(--color-${iconColor})` : 'currentColor';
  let textContent = <button dangerouslySetInnerHTML={{ __html: text || '' }} {...sharedProps} {...rest} />;
  if ((rightIconName || leftIconName) && text) {
    const leftIconToUse = leftIconName && <Icon iconName={leftIconName} />;
    const rightIconToUse = rightIconName && <Icon iconName={rightIconName} />;
    const newClassName = generateClassName([sharedProps.className, s.iconRow]);
    textContent = <button {...sharedProps} className={newClassName} style={{
      '--color-button-icon-fill': colorIcon,
    } as React.CSSProperties} {...rest}>{leftIconToUse}<span dangerouslySetInnerHTML={{ __html: text }}/>{rightIconToUse}</button>;
  }
  return (text
    ? (textContent)
    : (<button {...sharedProps} {...rest}>{children}</button>)
  );
};

export default Button;
